module.exports = __webpack_public_path__ + "static/img/testimony (74).22e71342.jpg";